/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ session: NonNullable<unknown> }} Plan_Build_Organize_UpInputs */

const en_us2_plan_build_organize_up = /** @type {(inputs: Plan_Build_Organize_UpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Move ${i?.session} up`)
};

const pt_br2_plan_build_organize_up = /** @type {(inputs: Plan_Build_Organize_UpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Subir ${i?.session}`)
};

const es_419_plan_build_organize_up = /** @type {(inputs: Plan_Build_Organize_UpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Subir ${i?.session}`)
};

const pt_pt2_plan_build_organize_up = /** @type {(inputs: Plan_Build_Organize_UpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Subir ${i?.session}`)
};

const fr_fr2_plan_build_organize_up = /** @type {(inputs: Plan_Build_Organize_UpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Monter ${i?.session}`)
};

const de_de2_plan_build_organize_up = /** @type {(inputs: Plan_Build_Organize_UpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.session} nach oben`)
};

const it_it2_plan_build_organize_up = /** @type {(inputs: Plan_Build_Organize_UpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sposta ${i?.session} in su`)
};

/**
* | output |
* | --- |
* | "Move {session} up" |
*
* @param {Plan_Build_Organize_UpInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_organize_up = /** @type {((inputs: Plan_Build_Organize_UpInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Organize_UpInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_organize_up(inputs)
	if (locale === "es-419") return es_419_plan_build_organize_up(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_organize_up(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_organize_up(inputs)
	if (locale === "de-DE") return de_de2_plan_build_organize_up(inputs)
	if (locale === "it-IT") return it_it2_plan_build_organize_up(inputs)
	return en_us2_plan_build_organize_up(inputs)
});
export { plan_build_organize_up as "plan-build.organize_up" }